import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Box, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { AlertBar } from '../Utils/Utils';
import { resetPasswordConfirm } from '../../Api/AuthApi';
import { useTranslation } from 'react-i18next';

export default function ResetPasswordForm() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [alertInfo, setAlertInfo] = useState({ severity: 'info', message: '' });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!token) {
            setAlertInfo({ severity: 'error', message: t('invalidToken') });
            setOpen(true);
        }
    }, [token]);

    const formik = useFormik({
        initialValues: {
            newPassword: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                await resetPasswordConfirm(token, values.newPassword);
                setAlertInfo({ severity: 'success', message: t('passwordChanged') });
                setOpen(true);
                setTimeout(() => navigate('/login'), 2000);
            } catch (error) {
                setAlertInfo({ severity: 'error', message: error.message || t('passwordChangeFailed') });
                setOpen(true);
            }
            setSubmitting(false);
        }
    });

    const handleClose = () => setOpen(false);

    return (
        <Container maxWidth="sm">
            <Box sx={{ marginTop: 12, textAlign: 'center' }}>
                <Typography variant="h5">{t('resetPassword')}</Typography>
            </Box>
            <Box sx={{ mt: 3 }}>
                <form onSubmit={formik.handleSubmit}>
                    <TextField
                        fullWidth
                        margin="normal"
                        id="newPassword"
                        name="newPassword"
                        label={t('newPassword')}
                        type="password"
                        value={formik.values.newPassword}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.newPassword && Boolean(formik.errors.newPassword)}
                        helperText={formik.touched.newPassword && formik.errors.newPassword}
                    />
                    <Button
                        color="primary"
                        type="submit"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 2 }}
                    >
                        {t('changePassword')}
                    </Button>
                </form>
            </Box>
            <AlertBar open={open} handleClose={handleClose} message={alertInfo.message} severity={alertInfo.severity} />
        </Container>
    );
}
